import React, { useState } from "react";

export default function VideoPlayer({
  videoUrl,
  title,
  description,
  views,
  onClose,
}) {
  const [isLiked, setIsLiked] = useState(false);
  const [likes, setLikes] = useState(0);
  const [isMaximized, setIsMaximized] = useState(false);
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");

  const toggleLike = () => {
    setIsLiked(!isLiked);
    setLikes(isLiked ? likes - 1 : likes + 1);
  };

  const toggleMaximize = () => {
    setIsMaximized(!isMaximized);
  };

  const handleCommentSubmit = (e) => {
    e.preventDefault();
    if (newComment.trim()) {
      const commentData = {
        text: newComment.trim(),
        user: "Usuario Anonimo", // Nombre de usuario ficticio
        avatar: "https://api.dicebear.com/9.x/avataaars-neutral/svg?seed=Riley", // Avatar de usuario ficticio
        timestamp: new Date(),
      };
      setComments([...comments, commentData]);
      setNewComment("");
    }
  };

  // Función para calcular el tiempo relativo
  function formatTimeAgo(date) {
    const seconds = Math.floor((new Date() - new Date(date)) / 1000);
    const intervals = [
      { label: "año", seconds: 31536000 },
      { label: "mes", seconds: 2592000 },
      { label: "semana", seconds: 604800 },
      { label: "día", seconds: 86400 },
      { label: "hora", seconds: 3600 },
      { label: "minuto", seconds: 60 },
    ];

    for (const interval of intervals) {
      const amount = Math.floor(seconds / interval.seconds);
      if (amount >= 1) {
        const pluralLabel =
          interval.label === "mes" && amount > 1
            ? "meses"
            : interval.label + (amount > 1 ? "s" : "");
        return `Hace ${amount} ${pluralLabel}`;
      }
    }
    return "Justo ahora";
  }

  return (
    <div className={`p-4 ${isMaximized ? "fixed inset-0 z-50 bg-black" : ""}`}>
      {/* Contenedor de Video */}
      <div
        className={`relative ${isMaximized ? "h-full" : "aspect-video"} bg-gray-900`}
      >
        <video src={videoUrl} controls className="h-full w-full"></video>
        {/* Botón de Maximización */}
        <button
          onClick={toggleMaximize}
          className="absolute right-16 top-2 rounded bg-black bg-opacity-50 p-2 text-xs text-white hover:bg-opacity-75"
        >
          {isMaximized ? "Minimizar" : "Maximizar"}
        </button>
        {/* Botón de Cerrar */}
        <button
          onClick={onClose}
          className="absolute right-2 top-2 rounded bg-red-600 p-2 text-xs text-white hover:bg-red-500"
        >
          Cerrar
        </button>
      </div>

      {/* Información del Video */}
      <div className="mt-4">
        <h2 className="text-xl font-semibold">{title}</h2>
        <p className="text-gray-600">{description}</p>
        <div className="mt-2 flex items-center">
          <span className="text-sm text-gray-500">{views} vistas</span>
          <button
            onClick={toggleLike}
            className={`ml-4 rounded p-2 text-sm font-semibold ${
              isLiked ? "text-blue-500" : "text-gray-500"
            } hover:text-blue-500`}
          >
            👍 {isLiked ? "Me Gusta" : "Dar Like"} ({likes})
          </button>
        </div>
      </div>

      {/* Sección de Comentarios */}
      <div className="mt-6">
        <h3 className="text-lg font-semibold text-gray-600">Comentarios</h3>
        <form onSubmit={handleCommentSubmit} className="mt-4 flex">
          <input
            type="text"
            value={newComment}
            onChange={(e) => setNewComment(e.target.value)}
            placeholder="Agregar un comentario..."
            className="flex-1 rounded-l border border-gray-300 bg-gray-200 p-2 text-gray-700 placeholder-gray-400"
          />
          <button
            type="submit"
            className="rounded-r bg-blue-500 p-2 text-white hover:bg-blue-600"
          >
            Comentar
          </button>
        </form>
        <div className="mt-4 space-y-4">
          {comments.map((comment, index) => (
            <div
              key={index}
              className="flex items-start space-x-3 rounded bg-gray-600 p-3"
            >
              {/* Avatar */}
              <img
                src={comment.avatar}
                alt={`${comment.user} avatar`}
                className="h-10 w-10 rounded-full"
              />
              <div className="flex-1">
                {/* Nombre de usuario y tiempo */}
                <div className="flex items-center space-x-2 text-gray-200">
                  <span className="font-semibold">{comment.user}</span>
                  <span className="text-xs text-gray-500">
                    {formatTimeAgo(comment.timestamp)}
                  </span>
                </div>
                {/* Texto del comentario */}
                <p className="text-gray-200">{comment.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
